import { makeRequest } from '~shared/api/make-request';
import { config } from '~shared/config';

import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { useMutation } from '@tanstack/react-query';

import { isPendingError, OcrResponse, PendingError } from './file-upload-api';

export type GetOcrResultParams = {
  transactionId: string;
  signal?: AbortSignal;
};

export function useGetOcrResult() {
  return useMutation({
    mutationFn: async ({ transactionId, signal }: GetOcrResultParams) => {
      const response = await makeRequest<ResponseSuccess<OcrResponse>>({
        url: `${config.apiHost}/kyc/api/v1/get_ocr_result`,
        credentials: 'include',
        cache: false,
        payload: { transactionId },
        timeout: 60 * 1000,
        signal,
      }).then((response) => response.payload);

      if (response.status === 'PENDING') {
        throw new PendingError();
      }
      return response;
    },
    retry: (count, error) => {
      return count < 8 && isPendingError(error);
    },
  });
}
